<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    id="gen-2-main"
    class="layout--main"
    :class="[{ 'app-page': isAppPage }]"
  >
    <b-overlay
      id="main-overlay-background"
      no-center
      :show="mainOverlayActive"
      variant="tranparent"
      opacity=0.85
      blur="5px"
      :style="mainOverlayActive ? 'height: 98vh !important;' : 'height: 90vh !important;'"
    >
      <template #overlay>
        <div class="overlay-content text-center">
          <b-icon icon="stopwatch" font-scale="3" animation="throb"></b-icon>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>


      <b-overlay
        id="video-overlay-background"
        no-center
        :show="videoOverlayActive"
        variant="dark"
        opacity=0.85
        blur="5px"
        :style="videoOverlayActive ? 'height: 98vh !important;' : 'height: 90vh !important;'"
      >
        <template #overlay>
          <div class="overlay-content">
            <div class="player">
              <video class="video-js gen2-videojs" id="videojs" ref="undefined" autoplay controls></video>
            </div>
            <div id="video-navigation-container" class="vx-row mt-2">
              <div class="vx-col w-full flex">
                <div id="main-video-counter">
                  <div class="flex">
                    <span>{{currentVideoIndex+1}}</span>
                    <span>&nbsp;of&nbsp;</span>
                    <span>{{videoList.length}}</span>
                  </div>
                </div>
                <div class="next-video-btn text-center cursor-pointer" :class="[{ 'disabled': !videoFinished && !allVideosFinished, 'nav-green-gradient-bg': videoFinished && !allVideosFinished }]" @click="playNextVideo">
                  <feather-icon v-if="!allVideosFinished" icon="ChevronRightIcon" svgClasses="h-8 w-8" />
                  <h4 v-else class="font-gen2-gradient-green">Done!</h4>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div id="content-area" :class="[{ 'show-overlay': bodyOverlay, 'disable-pointer-events': videoOverlayActive }]">
          <div id="content-overlay"></div>

          <div class="content-wrapper">
            <div class="router-view">
              <div class="router-content mt-0">

                <div id="gen2-back-button-container" v-if="!hideBackButton">
                  <div id="gen2-back-button" class="float-left">
                    <div @click="goBack">
                      <custom-svg variant="arrow" width="70" height="70" :color="$getSiteId() == 33 || $getSiteId() == 35 ? 'white' : 'gradient-light'" dir="left" class="cursor-pointer" />
                    </div>
                  </div>
                  <div id="gen2-download-button" class="float-right" v-if="showDownloadButton && $route.name == 'Gen2DocumentViewer'">
                    <div @click="downloadPdf">
                      <feather-icon icon="DownloadIcon" svgClasses="h-8 w-8" />
                    </div>
                  </div>
                </div>

                <transition :name="routerTransition">
                  <div
                    class="router-header flex flex-wrap items-center mb-6"
                    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                  >
                    <div
                      class="content-area__heading"
                      :class="{
                        'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light':
                          $route.meta.breadcrumb,
                      }"
                    >
                      <h2 class="mb-1">{{ routeTitle }}</h2>
                    </div>
                    <vx-breadcrumb
                      class="ml-4 md:block hidden"
                      v-if="$route.meta.breadcrumb"
                    />
                  </div>
                </transition>
                <div class="content-area__content mb-base" style="margin-top: 7rem;">
                  <!-- <back-to-top
                    bottom="15%"
                    visibleoffset="30"
                    v-if="!hideScrollToTop"
                  >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-arrow-up"
                      class="shadow-lg"
                      radius
                      size="large"
                    />
                  </back-to-top> -->
                  <transition :name="routerTransition" mode="out-in">
                    <router-view @changeRouteTitle="changeRouteTitle" @toggleDownloadButton="toggleDownloadButton"></router-view>
                  </transition>
                </div>
              </div>
            </div>
          </div>

          <mobile-nav :routeName="routeName"
                      @changeBackgroundColor="changeBackgroundColor"/>
        </div>
      </b-overlay>
    </b-overlay>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import BackToTop from "vue-backtotop";
import MobileNav from "@/gen-2/components/MobileNav.vue";
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import Plyr from 'plyr';
import videojs from 'video.js';
import streaming  from '@videojs/http-streaming'; 
import 'plyr/dist/plyr.css';
import { uuid } from 'vue-uuid';
export default {
  components: {
    BackToTop,
    MobileNav,
    CustomSvg,
    videojs,
    streaming,
  },
  data() {
    return {
      routerTransition: "fade",
      // routerTransition: themeConfig.routerTransition || "none",
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
      mainOverlayActive: false,
      videoOverlayActive: false,
      currentVideoIndex: 0,
      video: {},
      videoList: [],
      hardcodedVideoList: [
        {
          taskId: 79655,
          url: "https://content.digicampus.co.za/lateralscaffolding/Coca-Cola_Auto/2021_10/What is up ahead for me_1634890179696/index.m3u8"
        },
        {
          taskId: 79656,
          url: "https://content.digicampus.co.za/lateralscaffolding/Coca-Cola_Auto/2021_10/What will my journey look like_1634890219767/index.m3u8"
        },
        {
          taskId: 79657,
          url: "https://content.digicampus.co.za/lateralscaffolding/Coca-Cola_Auto/2021_10/How To Find Your Way_1634890092679/index.m3u8"
        },
        {
          taskId: 79658,
          url: "https://content.digicampus.co.za/lateralscaffolding/Coca-Cola_Auto/2021_10/Navigation UI centered_1634903575805/index.m3u8"
        },
        {
          taskId: 79659,
          url: "https://content.digicampus.co.za/lateralscaffolding/Coca-Cola_Auto/2021_10/Tips to help you learn on your mobile device-_1634890258545/index.m3u8"
        },
        {
          taskId: 79660,
          url: "https://content.digicampus.co.za/lateralscaffolding/Coca-Cola_Auto/2021_10/Where and how can i find help_1634890133888/index.m3u8"
        }
      ],
      videoFinished: false,
      allVideosFinished: false,
      uuid: "",
      queue: [],
      logData: {},
      showDownloadButton: false,
      documentUrl: null
    };
  },
  watch: {
    videoFinished: function(val) {
      if (val && this.currentVideoIndex == (this.videoList.length - 1)) {
        this.allVideosFinished = true;
      } else {
        this.allVideosFinished = false;
      }
      return;
    }
  },
  computed: {
    routeName: function() {
      return this.$route.name;
    },
    routeTitle: function () {
      return this.$route.meta.pageTitle;
    },
    logoUrl: function () {
      if (localStorage.getItem("userSiteInfo")) {
        if (JSON.parse(localStorage.getItem("userSiteInfo")) instanceof Array) {
          return JSON.parse(localStorage.getItem("userSiteInfo"))[0].logoUrl;
        } else {
          return JSON.parse(localStorage.getItem("userSiteInfo")).logoUrl;
        }
      }
    },
    siteName: function () {
      if (localStorage.getItem("userSiteInfo")) {
        if (JSON.parse(localStorage.getItem("userSiteInfo")) instanceof Array) {
          return JSON.parse(localStorage.getItem("userSiteInfo"))[0].name;
        } else {
          return JSON.parse(localStorage.getItem("userSiteInfo")).name;
        }
      }
    },
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    hideBackButton: function() {
      switch (this.$route.name) {
        case "Gen2Learn":
        case "Gen2Calendar":
        case "Gen2Trade":
        case "Gen2Wallet":
        case "Gen2Chat":
        case "Gen2Menu":
        case "Gen2StudentProfile":
        case "Gen2Campus":
        case "Gen2Support":
          return true;
        default:
          return false;
      }
    }
  },
  methods: {
    toggleDownloadButton(val, url) {
      this.showDownloadButton = val;
      if (url) {
        this.documentUrl = url;
      }
    },
    downloadPdf() {
      window.open(this.documentUrl, '_blank');
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    changeBackgroundColor(color) {
      var bodyEl = document.getElementsByTagName('body')[0];

      if (this.$getSiteId() == 33 || this.$getSiteId() == 35) {
        bodyEl.style.backgroundColor = "rgb(38, 45, 74)";
        bodyEl.style.background = "rgb(38, 45, 74)";
      } else {
        bodyEl.style.backgroundColor = color;
        bodyEl.style.background = color;
      }
    },
    goBack() {
      var self = this;
      switch (self.$route.name) {
        case "Gen2LearningPrograms":
        case "Gen2Mentorships":
        case "Gen2CourseProgress":
        case "Gen2Status":
        case "Gen2Campus":
        case "Gen2Support":
          self.$router.push({ name: "Gen2Learn" });
          break;
        case "Gen2PracticalTimeCapture":
          self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" } });
          break;
        case "Gen2OutcomeTasks":
        case "Gen2VideoViewer":
        case "Gen2DocumentViewer":
        case "Gen2UploadViewer":
          var lpId = self.$route.query.moduleId;
          var lpName = self.$route.query.lpName;
          var lpNumber = self.$route.query.lpNumber;
          var selectedModule = self.$route.query.selectedTaskGroup;
          var selectedOutcome = self.$route.query.selectedOutcome;
          var timeCapture = self.$route.query.timeCapture ? JSON.parse(self.$route.query.timeCapture) : {};
          if (self.$route.query.outcome) {
            self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: lpId, lpName: lpName, lpNumber: lpNumber, selectedTaskGroup: selectedModule, selectedOutcome: selectedOutcome, timeCapture: JSON.stringify(timeCapture) } });
          } else {
            self.$router.push({ name: "Gen2LearningPrograms", params: { lp: {moduleId: lpId, moduleName: lpName, lpNumber: lpNumber}, selectedTaskGroup: selectedModule } });
          }
          break;
        case "Gen2Mentoring":
          self.$router.push({ name: "Gen2Mentorships" });
          break;
        case "Gen2Q&A":
        case "Gen2Media":
        case "Gen2CallBack":
        case "Gen2MentorChat":
          self.$router.push({ name: "Gen2Mentoring", query: { module: self.$route.query.module, n: self.$route.query.n } });
          break;
        case "Gen2ReviewTasks":
          self.$router.push({ name: "Gen2Status" });
          break;
        default:
          break;
      }
    },
    getWatchedIntroVideos() {
      var self = this;

      self.mainOverlayActive = true;

      var taskIds = self.hardcodedVideoList.map(x => x.taskId);

      var onSuccess = (response) => {
        var videosWatched = response.data;
        self.videoList = self.hardcodedVideoList.filter(x => !videosWatched.includes(x.taskId));
        if (self.videoList.length > 0) {
          self.initVideosOverlay();
        } else {
          self.allVideosFinished = true;
          self.mainOverlayActive = false;
          self.videoOverlayActive = false;
        }
      };

      self.$ajaxPost(self, "Student/GetWatchedIntroVideos", taskIds, onSuccess);
    },
    initVideosOverlay() {
      var self = this;

      self.mainOverlayActive = false;

      self.videoOverlayActive = true;
      self.createStartLog();
      setTimeout(() => {
        self.playVideo();
      }, 100);
    },
    playVideo() {
      var self = this;

      self.videoFinished = false;

      self.video = self.videoList[self.currentVideoIndex];
      
      var searchMask = "/index.m3u8";
      var regEx = new RegExp(searchMask, "ig");
      var replaceMask = ".mp4";
      var player = videojs(document.getElementById("videojs"));
      if (!self.video.url.includes(".mp4")){
        player.on('error', function(err) {
          if(( player.error().code == 2 || player.error().code == 4) && !self.video.url.includes(".mp4")){
            setTimeout(function(){
              self.video.url = self.video.url.replace(regEx, replaceMask);
              player.src({ type: "video/mp4", src: self.video.url});

              player.play();
            },200)
          } 
        });
        
        player.ready(function(){
          this.on("ended", function(){ 
            self.videoFinished = true;
          });
        });
        player.src({ type: "video/x-mpegURL", src: self.video.url });
        player.play();
        return;
      }
    },
    playNextVideo() {
      var self = this;
      if (!self.allVideosFinished) {
        self.currentVideoIndex += 1;
        self.createEndLog(() => {
          self.createStartLog();
        });
        self.playVideo();
      } else {
        self.videoOverlayActive = false;
        self.createEndLog();
      }
    },
    playPreviousVideo() {
      var self = this;
      self.currentVideoIndex -= 1;
      self.playVideo();
    },
    createStartLog() {
      var self = this;

      // self.currentTask = self.nextTask;

      self.uuid = self.$uuid.v4();
      self.logData.taskId = self.videoList[self.currentVideoIndex].taskId;
      self.logData.logIdentifier = self.uuid;
      self.logData.toTaskId = null;

      // self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
      // self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

      // self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

      self.enqueue("VideoTask/StartLogEntry", self.logData);
    },
    createEndLog(whenDone) {
      var self = this;

      self.logData.logIdentifier = self.uuid;
      // self.logData.fromTaskId = self.currentTask.id;
      // self.logData.toTaskId = self.nextTask.id;
      self.enqueue("VideoTask/EndLogEntry", self.logData);
      if (whenDone && typeof whenDone == "function")
        whenDone();
    },
    enqueue(messageType, logPayload) {
      this.queue.push({
        type: messageType,
        payload: {
          logIdentifier: logPayload.logIdentifier.toString(),
          toTaskId: logPayload.toTaskId,
          fromTaskId: logPayload.fromTaskId,
          taskId: logPayload.taskId,
        }
      })
    },
    dequeue() {
      return this.queue.shift();
    },
    startProcessor() {
      var self = this;
      var onSuccess = function (response) {
        var next = self.dequeue();
        if (next)
          self.process(next, onSuccess);
      };
      setInterval(function () {
        if (self.queue.length > 0) {
          self.process(self.dequeue(), onSuccess)
        }
      }, 3000)
    },
    process(queueItem, successFunc) {
      var self = this;
      if (queueItem) {
        self.$ajaxPost(self, queueItem.type, queueItem.payload, function (response) {
          successFunc();
        });
      }
    },
  },
  created() {
    this.$store.dispatch("updateTheme", "dark");
  },
  mounted() {
    var self = this;

    if (self.$getSiteId() == 35) {
      self.startProcessor();

      self.getWatchedIntroVideos();
    }

    this.$setColors();
  },
};
</script>

<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>

<style lang="scss">
#gen-2-main {
  margin: auto !important;
  #content-area {
    text-align: -webkit-center;
    text-align: -moz-center;
    margin-left: 0 !important;
    transition: none !important;

    .router-view {
      padding: 0 !important;
      .router-content {
        padding-bottom: 60px !important; // ********** Add this when the Mobile Nav component is visible
        max-width: 450px !important;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
  background: transparent; /* optional: just make scrollbar invisible */
}

.disable-pointer-events {
  pointer-events: none !important;
}
</style>
